import { Card, Col, Row } from 'antd'
import { ReactComponent as SubjectIcon } from '../../assets/Dashboard/total-subject.svg'
import { Book02Icon } from 'hugeicons-react';

const TotalSubject = (data: any) => {
    return (
        <Card className='border-radius-md'>
            <Row gutter={24} align={'middle'}>
                <Col>
                    <div className='d-flex p-16 border-radius-lg' style={{ background: '#663690' }}>
                        <Book02Icon color='white' />
                    </div>
                </Col>
                <Col span={18}>
                    <p className='m-0 font-color-gray fs-14 fw-500'>Toplam Konu</p>
                    <h3 className='m-0 font-color-dark-blue fs-24 fw-700'>{data?.data?.total ?? '0'}</h3>
                </Col>
            </Row>
        </Card>
    )
}

export default TotalSubject